import * as React from "react";
import type { SVGProps } from "react";
const SvgIconLaundryRoom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 21 21"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.96.01c-1.44.1-2.7.94-3.37 2.26-.54 1.08-.54 2.43 0 3.53.51 1.06 1.48 1.86 2.58 2.14.52.14.2.13 4.86.14 3.14 0 4.36 0 4.5-.02 1.06-.15 1.92-1.01 2.08-2.08.01-.13.02-.74.01-2.05V2.07l-.07-.23c-.27-1-1.09-1.7-2.1-1.82C15.27 0 7.32 0 6.97.02M6.9 1.74c-.78.12-1.41.58-1.76 1.27-.27.55-.31 1.24-.1 1.8q.4 1.13 1.56 1.47c.33.1.57.1 4.74.1l4-.01.13-.06q.26-.12.38-.38c.06-.13.06-.16.06-.58V4.9h-4.46l-4.46-.02-.14-.07c-.18-.08-.36-.28-.43-.46-.07-.2-.06-.5.02-.66q.14-.27.4-.41l.17-.08h4.46l4.46-.01v-.45c-.02-.54-.05-.63-.26-.82-.23-.21.18-.2-4.53-.2-2.3 0-4.2.02-4.24.02M.66 9.58c-.17.04-.27.1-.4.23q-.32.31-.25.75c.04.2.1.31.24.45.23.23.38.27 1.03.27h.43l.02.06.62 3.75.66 3.88c.14.58.5 1.1 1.03 1.44.34.23.66.35 1.06.4.28.03 10.33.03 10.61 0 .4-.05.72-.17 1.06-.4.53-.35.9-.86 1.03-1.44l.66-3.88.62-3.75.02-.06h.44c.64 0 .8-.04 1.02-.27q.3-.3.24-.75c-.04-.19-.1-.3-.24-.45-.14-.14-.26-.2-.45-.24C19.9 9.53.84 9.54.66 9.58m2.81 1.73.6 3.64c.42 2.5.62 3.64.65 3.72q.1.21.33.35l.11.07h5.2c4.7.01 5.2 0 5.3-.03.16-.05.36-.24.43-.39.04-.08.23-1.17.65-3.72l.6-3.64c0-.03-.76-.03-6.93-.03s-6.94 0-6.94.03m5.1 1.46c-.23.08-.44.26-.54.47-.05.12-.06.17-.06.35 0 .2 0 .23.08.38q.14.28.4.4l.12.06h3.67l.11-.05q.28-.14.41-.41c.07-.15.08-.18.08-.38 0-.18 0-.23-.06-.35-.08-.16-.26-.35-.43-.43l-.13-.06h-1.78c-1.38 0-1.8 0-1.87.02"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconLaundryRoom;
